module.exports = __webpack_public_path__ + "static/img/dialog4.a36a76b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/dialog4.png
// module id = rmhC
// module chunks = 0